module.exports = __webpack_public_path__ + "img/4817.f0c6c552.jpg";